<div class="container share-list-container">
    <div class="row">
        <div class="col-12">
            <div class="share-list-url-description">
                @if (showReferralCreditProgram) {
                    <span translate="cart.share.list.link.description.pc"></span>
                } @else {
                    <span translate="cart.share.list.link.description"></span>
                }
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-2">
            <div class="list-nav-heading" translate="cart.share.lists.header"></div>
            @if (shareLists?.length > 0) {
                <div class="list-nav-body">
                    @for (list of shareLists; track list.shareListId) {
                        <div class="d-none d-sm-block">
                            <div (click)="setActiveList(list)" class="list-item padding-lr-5"
                                 [ngClass]="shareList == list ? 'list-active' : ''">
                                {{list.listName}}
                            </div>
                        </div>
                    }
                    <select [(ngModel)]="shareList" (ngModelChange)="setActiveList($event)" id="shareList" class="form-control d-block d-sm-none form-select">
                        @for (list of shareLists; track list.shareListId) {
                            <option class="opt-class" [ngValue]="list" >{{list.listName}}</option>
                        }
                    </select>
                </div>
            }
            <div class="list-nav-footer">
                <div class="add-new-list" [ngClass]="isBusy ? 'isDisabled' : ''" (click)="createNewList()"
                     translate="cart.new.share.list"></div>
            </div>
        </div>
        @if (shareLists?.length > 0) {
            <div class="col-sm-10 panel share-list-panel">
                @if (sponsorErrorTag) {
                    <general-error [generalErrorClass]="'tab-notification red'" [titleTag]="sponsorErrorTag" [bodyTag]="'cart.shareable.sponsor.validation.error.body'"></general-error>
                }
                <div class="panel-heading">
                    <div class="row">
                        <div class="col-sm-6 col-8">
                        <span [hidden]="editingName">
                            {{shareList.listName}}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a (click)="editName();">
                                <span class="share-edit-links" translate="cart.share.list.edit.name"></span>
                            </a>
                            <span class="fa-solid fa-circle-info cursor-pointer" (click)="showChangeShareListNameInfo();"></span>
                        </span>
                            <label [hidden]="!editingName">
                                <input type="text" class="form-control" size="30" [(ngModel)]="shareList.listName" maxlength="60">
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a (click)="!!shareList.listName && saveListName();" [ngClass]="{isDisabled: !shareList.listName}">
                                    <span class="share-edit-links margin-right-16" translate="cart.save"></span>
                                </a>
                                <a (click)="cancelEditingName();">
                                    <span class="share-edit-links" translate="cart.cancel"></span>
                                </a>
                            </label>
                        </div>
                        <div class="col-sm-6 col-4">
                            <div class="pull-right">
                                @if (showFbShareables) {
                                    <facebook-button
                                        class="share-list-facebook-button"
                                        [shareOptions]="shareOptions"></facebook-button>
                                }
                                @if (showUrlShareables) {
                                    <copy-short-url
                                        class="share-list-url"
                                        buttonClass="btn-primary"
                                        [shareOptions]="shareOptions"></copy-short-url>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    @for (slp of shareList.shareListProducts; track slp.productOrder) {
                        <div class="cart-line-item cart-underline clearfix">
                            <div class="col-2 padding-lr-5 cart-image-div">
                                <product-image
                                    imageClass="image-thumbnail"
                                    [images]="slp.product.productImages"
                                    imageType="productImage"
                                    imageSize="TH">
                                </product-image>
                            </div>

                            <div class="col-5 col-sm-6 col-lg-7 padding-lr-5 cart-description">
                                <span [innerHTML]="slp.product.productDescription.fullDisplayName"></span>
                                <div class="clearfix">
                                    <span><b>{{slp.product.price.price | usanacurrency | async}}</b></span>
                                    @if (shouldDisplayVolume) {
                                        <span> &nbsp;&nbsp; <span
                                            translate="cart.product.volume"></span> {{ slp.product.price.volume }}</span>
                                    }
                                </div>
                            </div>

                            <div class="col-4 col-sm-3 col-lg-2 no-padding cart-quantity">
                                <div class="quantity-container">
                                    @if (slp.quantity > 1) {
                                        <input type="button" [attr.aria-label]="'cart.remove.one.label'| translate" class="cart-minus-plus btn list-quantity-button"
                                               (click)="decrement(slp)" value="-">
                                    } @else {
                                        <ng-container *ngTemplateOutlet="notAllowed"></ng-container>
                                    }
                                    <div class="padding-lr-5 cart-quantity-input list-quantity-input">
                                        {{slp.quantity}}
                                    </div>
                                    <input type="button" [attr.aria-label]="'cart.add.one.label'| translate" class="cart-minus-plus btn list-quantity-button"
                                           (click)="increment(slp)" value="+">
                                </div>
                            </div>

                            <ng-template #notAllowed>
                                <span aria-disabled="true" class="cart-minus-plus list-quantity-button not-allowed">-</span>
                            </ng-template>

                            <div class="col-1 padding-lr-5 text-end">
                        <span class="cart-remove text-danger" [attr.aria-label]="'cart.remove.label'| translate" (click)="remove(slp)">
                            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                        </span>
                            </div>
                        </div>
                    }
                    <quick-search (selectedProduct)="addProductToShareList($event)"
                                  [warehouse]="currentWarehouse?.warehouse"
                                  [shopModeOverride]="shopMode" class="margin-top-10 d-block"></quick-search>
                </div>
                <div class="panel-footer">
                    <div class="row text-left">
                        <div class="col-5 col-sm-7 delete-btn">
                            <button class="btn btn-danger margin-left-10 margin-top-10 "
                                    (click)="deleteShareList()" [disabled]="isBusy">
                                <span translate="cart.delete"></span>
                            </button>
                        </div>

                        <div class="col-3 col-sm-3 text-end">
                            <div translate="cart.autoorder.total"></div>
                            @if (shouldDisplayVolume) {
                                <div translate="cart.autoorder.total.volume"></div>
                            }
                        </div>

                        <div class="col-4 col-sm-2 text-end">
                            <div><b>{{ shareList.totalPrice | usanacurrency | async }}</b></div>
                            @if (shouldDisplayVolume) {
                                <div><b>{{ shareList.totalVolume }}</b></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
